import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'D:/a/1/s/Web.API/client-app/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from 'D:/a/1/s/Web.API/client-app/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';
import {registerRoute as workbox_routing_registerRoute} from 'D:/a/1/s/Web.API/client-app/node_modules/workbox-routing/registerRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from 'D:/a/1/s/Web.API/client-app/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from 'D:/a/1/s/Web.API/client-app/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */




self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "index.html",
    "revision": "b1ad7db9be22751731adab125d9bcfa7"
  },
  {
    "url": "assets/workbox-window.prod.es5.e0cc53cf.js",
    "revision": null
  },
  {
    "url": "assets/workbox-window.prod.es5.2736b650.js",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.f2102fd9.js",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.e56cd9ff.css",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.dbbe0e4e.js",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.98c179b2.js",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.8fe36981.js",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.88f2c920.css",
    "revision": null
  },
  {
    "url": "assets/UpdateAddCustomer.62cf33ea.css",
    "revision": null
  },
  {
    "url": "assets/UnAuthorizedView.686a8e22.js",
    "revision": null
  },
  {
    "url": "assets/UnAuthorizedView.5ff871ca.js",
    "revision": null
  },
  {
    "url": "assets/UnAuthorizedView.322e4c0d.js",
    "revision": null
  },
  {
    "url": "assets/UnAuthorizedView.245c7841.js",
    "revision": null
  },
  {
    "url": "assets/Schedule.ed6ec6f6.js",
    "revision": null
  },
  {
    "url": "assets/Schedule.d2a93479.js",
    "revision": null
  },
  {
    "url": "assets/Schedule.c802c437.css",
    "revision": null
  },
  {
    "url": "assets/Schedule.82022d64.css",
    "revision": null
  },
  {
    "url": "assets/Schedule.18328c82.css",
    "revision": null
  },
  {
    "url": "assets/Schedule.18249643.js",
    "revision": null
  },
  {
    "url": "assets/Schedule.0fef0616.js",
    "revision": null
  },
  {
    "url": "assets/ResetPasswordView.e279831d.js",
    "revision": null
  },
  {
    "url": "assets/ResetPasswordView.b4864668.js",
    "revision": null
  },
  {
    "url": "assets/ResetPasswordView.ab85f0ee.js",
    "revision": null
  },
  {
    "url": "assets/ResetPasswordView.18f3fb7a.js",
    "revision": null
  },
  {
    "url": "assets/profile_pic.743ec105.png",
    "revision": null
  },
  {
    "url": "assets/primeicons.5e10f102.svg",
    "revision": null
  },
  {
    "url": "assets/primeicons.3824be50.woff2",
    "revision": null
  },
  {
    "url": "assets/PPEventCatalog.d74f32b7.js",
    "revision": null
  },
  {
    "url": "assets/PPEventCatalog.b0238b8f.js",
    "revision": null
  },
  {
    "url": "assets/PPEventCatalog.87d79560.js",
    "revision": null
  },
  {
    "url": "assets/PPEventCatalog.1881cc67.js",
    "revision": null
  },
  {
    "url": "assets/pp-logo.e71b7fab.png",
    "revision": null
  },
  {
    "url": "assets/pp-logo.a91cc66f.js",
    "revision": null
  },
  {
    "url": "assets/pp-logo.89bc6361.png",
    "revision": null
  },
  {
    "url": "assets/permpix-logo.4239d3e7.png",
    "revision": null
  },
  {
    "url": "assets/Logout.b5c66a39.js",
    "revision": null
  },
  {
    "url": "assets/Logout.a051158d.js",
    "revision": null
  },
  {
    "url": "assets/Logout.64950d90.js",
    "revision": null
  },
  {
    "url": "assets/Logout.1d93e0a8.js",
    "revision": null
  },
  {
    "url": "assets/Login.f604db1b.css",
    "revision": null
  },
  {
    "url": "assets/Login.cba09cce.js",
    "revision": null
  },
  {
    "url": "assets/Login.c6b35095.js",
    "revision": null
  },
  {
    "url": "assets/Login.3fc65b0b.js",
    "revision": null
  },
  {
    "url": "assets/Login.32a64909.js",
    "revision": null
  },
  {
    "url": "assets/led-strip.8c43080b.png",
    "revision": null
  },
  {
    "url": "assets/led-strip.89bc6361.png",
    "revision": null
  },
  {
    "url": "assets/index.ebe2dd04.css",
    "revision": null
  },
  {
    "url": "assets/index.c4d110c1.css",
    "revision": null
  },
  {
    "url": "assets/index.bd046ecb.js",
    "revision": null
  },
  {
    "url": "assets/index.b4d31f2f.js",
    "revision": null
  },
  {
    "url": "assets/index.aa5537b8.css",
    "revision": null
  },
  {
    "url": "assets/index.654ae156.js",
    "revision": null
  },
  {
    "url": "assets/index.30679eb1.js",
    "revision": null
  },
  {
    "url": "assets/Home.ef10d7f6.js",
    "revision": null
  },
  {
    "url": "assets/Home.baaa35af.js",
    "revision": null
  },
  {
    "url": "assets/Home.9b1bc482.js",
    "revision": null
  },
  {
    "url": "assets/Home.98a035ba.js",
    "revision": null
  },
  {
    "url": "assets/favicon.2a567338.ico",
    "revision": null
  },
  {
    "url": "assets/EventCatalog.ccf1ea3b.js",
    "revision": null
  },
  {
    "url": "assets/EventCatalog.a1534963.js",
    "revision": null
  },
  {
    "url": "assets/EventCatalog.64895b5b.js",
    "revision": null
  },
  {
    "url": "assets/EventCatalog.5248dcfd.js",
    "revision": null
  },
  {
    "url": "assets/Dashboard.f993985f.js",
    "revision": null
  },
  {
    "url": "assets/Dashboard.9f93532e.css",
    "revision": null
  },
  {
    "url": "assets/Dashboard.8748bde7.js",
    "revision": null
  },
  {
    "url": "assets/Dashboard.1aa05142.css",
    "revision": null
  },
  {
    "url": "assets/Dashboard.0c0ad739.js",
    "revision": null
  },
  {
    "url": "assets/Customers.ca45756a.js",
    "revision": null
  },
  {
    "url": "assets/Customers.bdd8a180.js",
    "revision": null
  },
  {
    "url": "assets/Customers.7b63f19e.js",
    "revision": null
  },
  {
    "url": "assets/Customers.602e30ec.js",
    "revision": null
  },
  {
    "url": "assets/company_logo.a0f254f4.png",
    "revision": null
  },
  {
    "url": "assets/color.473bc8ca.png",
    "revision": null
  },
  {
    "url": "assets/BoardSettings.f1fe98c7.js",
    "revision": null
  },
  {
    "url": "assets/BoardSettings.5174ec84.js",
    "revision": null
  },
  {
    "url": "assets/BoardSettings.3b0c8887.js",
    "revision": null
  },
  {
    "url": "assets/BoardSettings.05a2d1d1.js",
    "revision": null
  },
  {
    "url": "assets/Board.fd026609.js",
    "revision": null
  },
  {
    "url": "assets/Board.c9138b09.js",
    "revision": null
  },
  {
    "url": "assets/Board.c245e58d.js",
    "revision": null
  },
  {
    "url": "assets/Board.232eeeee.js",
    "revision": null
  },
  {
    "url": "assets/AccountDetailsView.b49a6ad3.js",
    "revision": null
  },
  {
    "url": "assets/AccountDetailsView.aa26a10b.js",
    "revision": null
  },
  {
    "url": "assets/AccountDetailsView.42a22d1c.js",
    "revision": null
  },
  {
    "url": "assets/AccountDetailsView.42751c1a.js",
    "revision": null
  },
  {
    "url": "assets/404.f139785b.js",
    "revision": null
  },
  {
    "url": "assets/404.beba4490.js",
    "revision": null
  },
  {
    "url": "assets/404.bc71d48b.js",
    "revision": null
  },
  {
    "url": "assets/404.8feafafc.js",
    "revision": null
  },
  {
    "url": "assets/windows11/Wide310x150Logo.scale-400.png",
    "revision": "02ffb97f215621088b272ef50032ed59"
  },
  {
    "url": "assets/windows11/Wide310x150Logo.scale-200.png",
    "revision": "d1f6ae8b5b03cdd65681f6594f101ec5"
  },
  {
    "url": "assets/windows11/Wide310x150Logo.scale-150.png",
    "revision": "e1e44356a62f29764fb22151b3831e4f"
  },
  {
    "url": "assets/windows11/Wide310x150Logo.scale-125.png",
    "revision": "fb25f1ebdecebcedc9780d91bf1309ef"
  },
  {
    "url": "assets/windows11/Wide310x150Logo.scale-100.png",
    "revision": "d7335b5f1b606abfc0571e987c9f8561"
  },
  {
    "url": "assets/windows11/StoreLogo.scale-400.png",
    "revision": "d7a617f57a829818fdb6c2f77553f09f"
  },
  {
    "url": "assets/windows11/StoreLogo.scale-200.png",
    "revision": "18968e926ab00b98ef59b0f5f8829430"
  },
  {
    "url": "assets/windows11/StoreLogo.scale-150.png",
    "revision": "f5c676cce21634da94af523a4aa44b89"
  },
  {
    "url": "assets/windows11/StoreLogo.scale-125.png",
    "revision": "99f63e08d6a515adac88c877fab46e89"
  },
  {
    "url": "assets/windows11/StoreLogo.scale-100.png",
    "revision": "3a434de12fed5810d507179f15cf5c86"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-96.png",
    "revision": "e591a3ea88040f33adfb90a3b7ed4ac7"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-80.png",
    "revision": "99cbf4a810bcc969c663b71a27ce9ea3"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-72.png",
    "revision": "3b5e5932c82fd6a7c27cc3b9d6d8fb9b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-64.png",
    "revision": "7a3b41c281366affdab0e26d45819086"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-60.png",
    "revision": "6e7f229e98447be62edb6e65654adc93"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-48.png",
    "revision": "7e0f84948cdf48a486e8b4b2ab415c16"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-44.png",
    "revision": "a7bc19262ce23da3b44c7f317515e2a5"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-40.png",
    "revision": "10403156f20ff501831b45f2654dc22b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-36.png",
    "revision": "d97698ee4b6f746a660179f901599e7e"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-32.png",
    "revision": "ea271b1b0461a047f36e2b19f03b4c06"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-30.png",
    "revision": "cfa6a0f5a656211253b9806d94e57791"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-256.png",
    "revision": "2fc66c4e4c3755054d76b5702c317951"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-24.png",
    "revision": "ca635cd4c79bea1118e800f9500d7077"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-20.png",
    "revision": "e99c896c9ea1f00105139dd32e479c98"
  },
  {
    "url": "assets/windows11/Square44x44Logo.targetsize-16.png",
    "revision": "847eb6ccfcfbba90641f051d4a4890f4"
  },
  {
    "url": "assets/windows11/Square44x44Logo.scale-400.png",
    "revision": "886d9c46186baf463db8af2fa2d60495"
  },
  {
    "url": "assets/windows11/Square44x44Logo.scale-200.png",
    "revision": "2a28a5700830210ebd6ed925b3365cd8"
  },
  {
    "url": "assets/windows11/Square44x44Logo.scale-150.png",
    "revision": "69244e4962d2cf5b359f30817bab6aff"
  },
  {
    "url": "assets/windows11/Square44x44Logo.scale-125.png",
    "revision": "a164049a6cb863958689303f0913fc19"
  },
  {
    "url": "assets/windows11/Square44x44Logo.scale-100.png",
    "revision": "a7bc19262ce23da3b44c7f317515e2a5"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-96.png",
    "revision": "e591a3ea88040f33adfb90a3b7ed4ac7"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-80.png",
    "revision": "99cbf4a810bcc969c663b71a27ce9ea3"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-72.png",
    "revision": "3b5e5932c82fd6a7c27cc3b9d6d8fb9b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-64.png",
    "revision": "7a3b41c281366affdab0e26d45819086"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-60.png",
    "revision": "6e7f229e98447be62edb6e65654adc93"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-48.png",
    "revision": "7e0f84948cdf48a486e8b4b2ab415c16"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-44.png",
    "revision": "a7bc19262ce23da3b44c7f317515e2a5"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-40.png",
    "revision": "10403156f20ff501831b45f2654dc22b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-36.png",
    "revision": "d97698ee4b6f746a660179f901599e7e"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-32.png",
    "revision": "ea271b1b0461a047f36e2b19f03b4c06"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-30.png",
    "revision": "cfa6a0f5a656211253b9806d94e57791"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-256.png",
    "revision": "2fc66c4e4c3755054d76b5702c317951"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-24.png",
    "revision": "ca635cd4c79bea1118e800f9500d7077"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-20.png",
    "revision": "e99c896c9ea1f00105139dd32e479c98"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-unplated_targetsize-16.png",
    "revision": "847eb6ccfcfbba90641f051d4a4890f4"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-96.png",
    "revision": "e591a3ea88040f33adfb90a3b7ed4ac7"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-80.png",
    "revision": "99cbf4a810bcc969c663b71a27ce9ea3"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-72.png",
    "revision": "3b5e5932c82fd6a7c27cc3b9d6d8fb9b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-64.png",
    "revision": "7a3b41c281366affdab0e26d45819086"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-60.png",
    "revision": "6e7f229e98447be62edb6e65654adc93"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-48.png",
    "revision": "7e0f84948cdf48a486e8b4b2ab415c16"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-44.png",
    "revision": "a7bc19262ce23da3b44c7f317515e2a5"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-40.png",
    "revision": "10403156f20ff501831b45f2654dc22b"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-36.png",
    "revision": "d97698ee4b6f746a660179f901599e7e"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-32.png",
    "revision": "ea271b1b0461a047f36e2b19f03b4c06"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-30.png",
    "revision": "cfa6a0f5a656211253b9806d94e57791"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-256.png",
    "revision": "2fc66c4e4c3755054d76b5702c317951"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-24.png",
    "revision": "ca635cd4c79bea1118e800f9500d7077"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-20.png",
    "revision": "e99c896c9ea1f00105139dd32e479c98"
  },
  {
    "url": "assets/windows11/Square44x44Logo.altform-lightunplated_targetsize-16.png",
    "revision": "847eb6ccfcfbba90641f051d4a4890f4"
  },
  {
    "url": "assets/windows11/Square150x150Logo.scale-400.png",
    "revision": "3d6ba60f9114a80a2f4fe4f003a7c2ff"
  },
  {
    "url": "assets/windows11/Square150x150Logo.scale-200.png",
    "revision": "c2049e2e2b34731b4d955df4b85ad215"
  },
  {
    "url": "assets/windows11/Square150x150Logo.scale-150.png",
    "revision": "5b4de7a076dff64b59d737f256aba354"
  },
  {
    "url": "assets/windows11/Square150x150Logo.scale-125.png",
    "revision": "0acf12cbf6cd08b7840d49c1f9eeffdc"
  },
  {
    "url": "assets/windows11/Square150x150Logo.scale-100.png",
    "revision": "876b9b86b0fbf3194a94b258dfde8757"
  },
  {
    "url": "assets/windows11/SplashScreen.scale-400.png",
    "revision": "c11d31e101df1084d810dacead1e2acf"
  },
  {
    "url": "assets/windows11/SplashScreen.scale-200.png",
    "revision": "02ffb97f215621088b272ef50032ed59"
  },
  {
    "url": "assets/windows11/SplashScreen.scale-150.png",
    "revision": "3e939668518db516be3d7f045f23a535"
  },
  {
    "url": "assets/windows11/SplashScreen.scale-125.png",
    "revision": "e4dbb3f3e792384dbcf1e5657d30ff65"
  },
  {
    "url": "assets/windows11/SplashScreen.scale-100.png",
    "revision": "d1f6ae8b5b03cdd65681f6594f101ec5"
  },
  {
    "url": "assets/windows11/SmallTile.scale-400.png",
    "revision": "05912742eb5c784869cea3399ac23e2e"
  },
  {
    "url": "assets/windows11/SmallTile.scale-200.png",
    "revision": "271015c709993908dfed59a73333d542"
  },
  {
    "url": "assets/windows11/SmallTile.scale-150.png",
    "revision": "ad3d6a94826e2835c068134848f542b0"
  },
  {
    "url": "assets/windows11/SmallTile.scale-125.png",
    "revision": "0811a09565ffa3eaa04a6ede02a5a74a"
  },
  {
    "url": "assets/windows11/SmallTile.scale-100.png",
    "revision": "b63cc80d96ca81700e873648bf04b1cf"
  },
  {
    "url": "assets/windows11/LargeTile.scale-400.png",
    "revision": "9835cbc824efddd94bc45c80fa676465"
  },
  {
    "url": "assets/windows11/LargeTile.scale-200.png",
    "revision": "2b682e2d4bbaf555847304ffe8929c25"
  },
  {
    "url": "assets/windows11/LargeTile.scale-150.png",
    "revision": "76c53170676652a275590d5b23501fea"
  },
  {
    "url": "assets/windows11/LargeTile.scale-125.png",
    "revision": "791ce64ccb7dc25cf15ce1b91f012ade"
  },
  {
    "url": "assets/windows11/LargeTile.scale-100.png",
    "revision": "1f8f1a70a033d3a081d1bbd49ab4a26f"
  },
  {
    "url": "assets/ios/87.png",
    "revision": "bf0ec7e124adc9ce1b9f5966c3dc6684"
  },
  {
    "url": "assets/ios/80.png",
    "revision": "0c7c381e22ae5b447b825c3fffea81fd"
  },
  {
    "url": "assets/ios/76.png",
    "revision": "651eff7b70c5c6829aad9093c68bc053"
  },
  {
    "url": "assets/ios/72.png",
    "revision": "43b757c094b811d022330ea6ba7b3a2c"
  },
  {
    "url": "assets/ios/64.png",
    "revision": "83b0bf6f00d3457bb0e812a54c15e81d"
  },
  {
    "url": "assets/ios/60.png",
    "revision": "ec1a572b3d9c0ba7af8f7321f62b5d2e"
  },
  {
    "url": "assets/ios/58.png",
    "revision": "257b28927879f5322275516921176964"
  },
  {
    "url": "assets/ios/57.png",
    "revision": "c3197c2e2aa824c56e40022cb6641eaa"
  },
  {
    "url": "assets/ios/512.png",
    "revision": "d8721113a1c13eb4f3c600b37400cacd"
  },
  {
    "url": "assets/ios/50.png",
    "revision": "3a434de12fed5810d507179f15cf5c86"
  },
  {
    "url": "assets/ios/40.png",
    "revision": "bb0481a5707196d99fb6d36d4f366673"
  },
  {
    "url": "assets/ios/32.png",
    "revision": "0bc52390fe69454a100e17cb5d402cd9"
  },
  {
    "url": "assets/ios/29.png",
    "revision": "b4a56db74cf0087f5b9a546840da051d"
  },
  {
    "url": "assets/ios/256.png",
    "revision": "28e0bc51bce995c9ddabfdeba0d48fb4"
  },
  {
    "url": "assets/ios/20.png",
    "revision": "6d1c60a3adfc47753e15239436a11449"
  },
  {
    "url": "assets/ios/192.png",
    "revision": "e2d2dfc1eb264f8f9122cc6627006677"
  },
  {
    "url": "assets/ios/180.png",
    "revision": "93f0fd8a4b9c36fdd28a2667f718174c"
  },
  {
    "url": "assets/ios/167.png",
    "revision": "d40e4561619e8cc22650aa75c8961a09"
  },
  {
    "url": "assets/ios/16.png",
    "revision": "2c3e177c42f89ec5e25a5e8d26e15766"
  },
  {
    "url": "assets/ios/152.png",
    "revision": "19f9a85caac148f8c0f373f5a73f0785"
  },
  {
    "url": "assets/ios/144.png",
    "revision": "a5c2cfdfccddd1c89a6a275d3814acc6"
  },
  {
    "url": "assets/ios/128.png",
    "revision": "dea0081701ec89cf382182e46f8c6c51"
  },
  {
    "url": "assets/ios/120.png",
    "revision": "a64dd08d1a90eca43d10bd3894a4beac"
  },
  {
    "url": "assets/ios/114.png",
    "revision": "60d80cbe58dacf059895c602224f9b11"
  },
  {
    "url": "assets/ios/1024.png",
    "revision": "93b27a32959e4a8ae71ccdae9193b1d0"
  },
  {
    "url": "assets/ios/100.png",
    "revision": "18968e926ab00b98ef59b0f5f8829430"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon.png",
    "revision": "c3197c2e2aa824c56e40022cb6641eaa"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-76x76.png",
    "revision": "651eff7b70c5c6829aad9093c68bc053"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-72x72.png",
    "revision": "43b757c094b811d022330ea6ba7b3a2c"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-57x57.png",
    "revision": "c3197c2e2aa824c56e40022cb6641eaa"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-180x180.png",
    "revision": "93f0fd8a4b9c36fdd28a2667f718174c"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-152x152.png",
    "revision": "19f9a85caac148f8c0f373f5a73f0785"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-144x144.png",
    "revision": "a5c2cfdfccddd1c89a6a275d3814acc6"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-120x120.png",
    "revision": "a64dd08d1a90eca43d10bd3894a4beac"
  },
  {
    "url": "assets/apple_touch/apple-touch-icon-114x114.png",
    "revision": "60d80cbe58dacf059895c602224f9b11"
  },
  {
    "url": "assets/android/android-launchericon-96-96.png",
    "revision": "3f6f92303691af3b51fc8370f5087eee"
  },
  {
    "url": "assets/android/android-launchericon-72-72.png",
    "revision": "43b757c094b811d022330ea6ba7b3a2c"
  },
  {
    "url": "assets/android/android-launchericon-512-512.png",
    "revision": "d8721113a1c13eb4f3c600b37400cacd"
  },
  {
    "url": "assets/android/android-launchericon-48-48.png",
    "revision": "5031448c1599a00253f58af57773738d"
  },
  {
    "url": "assets/android/android-launchericon-192-192.png",
    "revision": "e2d2dfc1eb264f8f9122cc6627006677"
  },
  {
    "url": "assets/android/android-launchericon-144-144.png",
    "revision": "a5c2cfdfccddd1c89a6a275d3814acc6"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "3ed03a85aae58349cfc7d3d69ea33451"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("index.html")));


